import { useEffect, useRef } from 'react';
import Player from './Player';
import './Drawcanvas.css';
import { useSelector } from 'react-redux'

function Messages() {
  const messageBox = useRef(null);
  const gameState = useSelector((state) => state.gameState );
  const ps = useSelector((state) => state.playerState );

  useEffect(() => {
    if (gameState != null && gameState.messages.length > 0) {
      messageBox.current.scrollTop = messageBox.current.scrollHeight;
    }
  }, [gameState.messages, gameState])
  
  if (gameState != null && gameState.messages.length > 0) {
    return (
      <div ref={messageBox} className="absolute flex flex-col overflow-y-auto h-5/6 md:h-full w-full"> {gameState.messages.map((message, i) => (
          <div className={(ps.id === message.authId) ? "flex justify-end mb-3" : "flex justify-start mb-3"}  key={i}>
            <div className='flex flex-col'>
              <div className={(ps.id === message.authId) ? "p-1 mb-1 justify-end text-right " : "p-1 mb-1 justify-start text-left"}>
                <Player player={message.author} />
              </div>
              <p className={(ps.id === message.authId) ? "break-all rounded-tl-lg rounded-br-lg rounded-bl-lg own-message p-1.5 ml-4 lg:ml-16 mr-2" : "break-all rounded-tr-lg rounded-br-lg rounded-bl-lg other-message p-1.5 ml-1.5 mr-4 lg:mr-16 ml-2"}>{message.text}</p>
            </div>
          </div>
        ))}
        </div>
    );  
  }
}

export default Messages;
